<script lang="ts">
  import Link from '../elements/Link.svelte';

  // *** This file is part of DbGate Premium ***

  import TableControl from '../elements/TableControl.svelte';
  import ConfirmModal from '../modals/ConfirmModal.svelte';
  import InputTextModal from '../modals/InputTextModal.svelte';
  import { showModal } from '../modals/modalTools';

  export let allConnections;
  export let checkedKeys = undefined;
  export let onSetCheckedKeys = undefined;
  export let onDelete = undefined;
  export let onCopy = undefined;
  export let filters = null;
</script>

<TableControl
  {filters}
  stickyHeader
  columns={[
    { header: 'ID', fieldName: 'id', sortable: true, filterable: true },
    { header: 'Display name', fieldName: 'displayName', sortable: true, filterable: true },
    { header: 'Engine', fieldName: 'engine', sortable: true, filterable: true },
    { header: 'Server', fieldName: 'server', sortable: true, filterable: true },
    { header: 'User', fieldName: 'user', sortable: true, filterable: true },
    (onDelete || onCopy) && {
      fieldName: 'actions',
      header: '',
      slot: 3,
    },

    //   {
    //     fieldName: 'actions',
    //     header: '',
    //     slot: 3,
    //   },
  ]}
  clickable
  rows={allConnections}
  on:clickrow
  {checkedKeys}
  {onSetCheckedKeys}
>
  <svelte:fragment slot="3" let:row>
    {#if onDelete}
      <Link
        onClick={async e => {
          e.stopPropagation();
          showModal(ConfirmModal, {
            header: 'Delete connection',
            message: `Are you sure you want to delete connection "${row.displayName || row.server || row.id}"?`,
            confirmLabel: 'Delete',
            onConfirm: () => {
              onDelete(row.id);
            },
          });
        }}>Remove</Link
      >
    {/if}
    {#if onCopy}
      <Link
        onClick={async e => {
          e.stopPropagation();
          showModal(InputTextModal, {
            header: 'Copy connection',
            label: 'New connection display name',
            value: `${row.displayName || row.server || row.id} - copy`,
            onConfirm: name => {
              onCopy(row.id, name);
            },
          });
        }}>Copy</Link
      >
    {/if}
  </svelte:fragment>
</TableControl>
